import { Badge } from "@/atoms"
import { AgentCell } from "../AgentCell"

import styles from "./ScopeCell.module.scss"

export const ScopeCell = (
  name: string,
  record: {
    type: "heading" | "scope" | "agent"
    count?: number
    description?: string
    // The group's heading shows the description
    groupedDescription?: boolean
  }
) => {
  const { type } = record

  if (type === "agent") return AgentCell(name)

  return (
    <div className={styles.container}>
      <span>{name}</span>
      {type === "scope" && record.description && !record.groupedDescription && (
        <span className={styles.description}>{record.description}</span>
      )}
      {type === "heading" && (
        <Badge className={styles.badge} count={record.count} />
      )}
      {type === "heading" && record.description && (
        <span className={styles.headingDescription}>{record.description}</span>
      )}
    </div>
  )
}
